import { CotDevice } from 'types/cot.types';
import { isInventoryProject } from './project.utils';

export const isAllocated = (cotDevice?: CotDevice | null) => {
  return cotDevice && !isInventoryProject(cotDevice.deviceProject);
};
